const FIREBASE_UID = /^[A-Za-z0-9]{20,36}$/;

function text(value) {
  return String(value || '').trim();
}

export function looksLikeUserId(value, user = {}) {
  const candidate = text(value);
  if (!candidate) return true;
  if (candidate.includes('@') || candidate.includes(' ')) return false;
  const ids = [user.id, user.uid, user.userId].map(text).filter(Boolean);
  if (ids.includes(candidate)) return true;
  return FIREBASE_UID.test(candidate);
}

export function userLabel(user = {}) {
  const email = text(user.email);
  const parts = [user.firstName, user.lastName].map(text).filter(Boolean).join(' ');
  const named = [user.displayName, user.name, parts, email];
  for (const candidate of named) {
    const label = text(candidate);
    if (label && !looksLikeUserId(label, user)) return label;
  }
  return email || 'Unnamed user';
}
